<template>
  <label for="resources-multiselect-component" class="form-label">
    {{ $t('resource.list') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedResources"
    :options="{
      create: false,
      placeholder: $t('resource.selectMore')
    }"
    class="w-full"
    multiple
  >
    <option
      v-for="resource in resources"
      :value="resource.uuid"
      :key="resource.uuid"
    >
      {{ resource.internalName }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import resourceApi from '../../services/resources/resource.api'

export default defineComponent({
  data() {
    return {
      resources: []
    }
  },
  mounted() {
    resourceApi.getList(1, 100).then(
      response => {
        this.resources = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedResources: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedResources'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedResources,
      set: value => emit('update:selectedResources', value)
    })

    return {
      componentValue
    }
  }
})
</script>
